<template>
  <div>
    <div class="form-group">
      <div id="card-element" class="form-control"></div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <div id="card-year" class="form-control"></div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <div id="card-cvc" class="form-control"></div>
        </div>
      </div>
    </div>
    <button v-on:click="buyPremium"
            @keyup.enter="buyPremium"
            :disabled="isLoading"
            class="btn btn-main w-100">
      {{ isLoading ? $lang.messages.get_premium_modal.wait_please : $lang.messages.get_premium }}
    </button>
  </div>
</template>

<script>

import {loadStripe} from '@stripe/stripe-js';
import firebase from "firebase/app";
import {API_HOST, STRIPE_KEY, STRIPE_KEY_TEST} from "@/helpers/stipe_const";
import {reportEvent} from "@/helpers/utils";

let cardElement = null;
let cardCvc = null;
let cardExpiry = null;
export default {
  name: 'stripeView',
  props: ['premiumPlan', 'customer', 'trial'],
  data: function () {
    return {
      prices: [],
      isPremiumPurchased: false,
      clientSecret: null,
      user: null,
      selectedPrice: null,
      isLoading: false,
      userCustomer: null,
      testPayment: localStorage.getItem('stripeTest'),
      pricesMap: [
        {
          type: 'month',
          id: 'price_1JIXpNJfRh4sLA5Q8LyLQR46'
        },
        {
          type: 'year',
          id: 'price_1JIXsOJfRh4sLA5QFTIgo9BB'
        },
      ]
    }
  },
  async mounted() {
    this.userCustomer = this.customer;
    this.user = firebase.auth().currentUser;
    /**
     * Getting prices from stripe from our api
     */
    fetch(`${API_HOST}/api/config${this.testPayment ? '?test=1' : ''}`).then(async (res) => {
      const pricesResponses = await res.json();
      this.prices = pricesResponses.prices;
    });

    this.stripe = await loadStripe(this.testPayment ? STRIPE_KEY_TEST : STRIPE_KEY);
    const elements = this.stripe.elements();

    cardElement = elements.create('cardNumber');
    cardElement.mount('#card-element');

    cardCvc = elements.create('cardCvc');
    cardCvc.mount('#card-cvc');

    cardExpiry = elements.create('cardExpiry');
    cardExpiry.mount('#card-year');

  },
  methods: {
    async createSub() {
      return await fetch(`${API_HOST}/api/create-subscription?customerId=${this.userCustomer.id}&priceId=${this.selectedPrice.id}${this.testPayment ? '&test=1' : ''}${this.trial ? '&trial=1' : ''}`, {}).then(r => r.json());
    },
    async createCustomer(methodID = null) {
      const createCustomer = await fetch(`${API_HOST}/api/create-customer?email=${encodeURIComponent(this.user.email)}${this.testPayment ? '&test=1' : ''}${methodID ? '&methodID=' + methodID : ''}`, {}).then(r => r.json());
      if (createCustomer.customer && createCustomer.customer.id) {
        this.userCustomer = createCustomer.customer
        this.$emit('updatesettings', {customer: createCustomer.customer})
      }
    },
    buyPremium: async function () {
      if (!this.premiumPlan) {
        alert('select plan');
        return false;
      }

      this.selectedPrice = this.prices ? this.prices.find((price) => {
        return price.id === this.localPrice.id
      }) : null;

      if (!this.selectedPrice ) {
        alert('selected price not found');
        return false;
      }

      this.isLoading = true
      let isError = false
      if (!this.userCustomer) {
        if (this.trial) {
          const methodObject = await this.stripe
              .createPaymentMethod({
                type: 'card',
                card: cardElement,
              });

          if (methodObject.error) {
            this.isLoading = false
            isError = true
            alert(methodObject.error.message)
          } else {
            await this.createCustomer(methodObject.paymentMethod.id)
          }
        } else {
          await this.createCustomer()
        }
      }
      if(!isError) {
        const createSub = await this.createSub();
        if (createSub.subscriptionId) {
          this.$emit('updatesettings', {stripeSubscriptionId: createSub.subscriptionId})
          if (this.trial) {
            this.isLoading = false;
            this.$emit('premiumispurchased')
            this.$analytics.fbq.event('Active_free_trial')
            // trail set
          } else {
            this.stripe
              .confirmCardPayment(createSub.clientSecret, {
                payment_method: {
                  card: cardElement,
                }
              })
              .then((result) => {
                if (result.error) {
                  // Show error to your customer
                  alert('error ' + result.error.message);
                  this.isLoading = false
                } else {
                  this.isLoading = false
                  reportEvent('premiumispurchased', {'email': this.user.email})
                  this.$analytics.fbq.event('Purchase', {value: '0.00', currency: 'USD', predicted_ltv: '0.00'})
                  this.$gtag.event('conversion', {
                    'send_to': 'AW-311471832/XiZgCLC3lPACENjdwpQB',
                    'value': 1.0,
                    'currency': 'USD'
                  })
                  this.$emit('premiumispurchased')
                }
              });
          }
        } else {
          alert('error:' + createSub.error.message)
        }
      }

    },
  },
  computed: {
    localPrice() {
      return this.pricesMap.find(price => price.type === this.premiumPlan)
    }
  },
  components: {}
}

</script>

<style lang="scss">

</style>
